var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "referral",
    class: _vm.isMobile && 'wap'
  }, [_c('p-head'), _c('div', {
    staticClass: "referral-main main",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "referral-head"
  }, [_c('div', {
    staticClass: "referral-intro"
  }, [_c('div', {
    staticClass: "referral-intro__title"
  }, [_vm._v(_vm._s(_vm.$lang("Grow the community. Earn together.")))]), _vm._m(0)]), _c('div', {
    staticClass: "referral-total"
  }, [_c('div', {
    staticClass: "referral-total-item power"
  }, [_c('div', {
    staticClass: "referral-total__bg"
  }), _c('div', {
    staticClass: "refreeal-total-info"
  }, [_c('div', {
    staticClass: "refreeal-total__title"
  }, [_vm._v(_vm._s(_vm.$lang("My Pop Points")))]), _c('div', {
    staticClass: "refreeal-total__price"
  }, [_vm._v(_vm._s(_vm.web3Data.myPower !== null && _vm.web3Data.myPower != 0 ? _vm.fmt_th(_vm.fmt_floatDec(_vm.web3Data.myPower) * 1000, 4, true, false) : "0"))])]), _vm._m(1)]), _c('div', {
    staticClass: "referral-total-item referral-power"
  }, [_c('div', {
    staticClass: "referral-total__bg"
  }), _c('div', {
    staticClass: "refreeal-total-info"
  }, [_c('div', {
    staticClass: "refreeal-total__title"
  }, [_vm._v(_vm._s(_vm.$lang("Referral Points")))]), _c('div', {
    staticClass: "refreeal-total__price"
  }, [_vm._v(_vm._s(_vm.web3Data.myRefPower !== null && _vm.web3Data.myRefPower != 0 ? _vm.fmt_pre(_vm.fmt_floatDec(_vm.web3Data.myRefPower) * 1000, 4, true, false) : 0))])]), _c('div', {
    staticClass: "referral-total__img"
  }, [_c('svg-icon', {
    attrs: {
      "name": "referral"
    }
  })], 1)])])]), _c('div', {
    staticClass: "referral-con"
  }, [_c('div', {
    staticClass: "referral-list"
  }, [_c('div', {
    staticClass: "referral-item"
  }, [_c('div', {
    staticClass: "referral-item__title"
  }, [_vm._v(_vm._s(_vm.$lang("Referred By")) + " "), _vm.userInfo && _vm.userInfo.bind === 0 || !_vm.isWallet ? [_vm._v("· " + _vm._s(_vm.$lang("Enter a referral code")))] : _vm._e(), _vm.userInfo && _vm.userInfo.bind === 1 ? [_vm._v("· " + _vm._s(_vm.$lang("Referral code applied")))] : _vm._e()], 2), _c('div', {
    staticClass: "referral-item-info"
  }, [_c('div', {
    staticClass: "referral-input"
  }, [_vm.userInfo && _vm.userInfo.bind === 1 ? _c('div', {
    staticClass: "input"
  }, [_vm._v(_vm._s(_vm.userInfo.referral_encode))]) : _vm.userInfo && _vm.userInfo.bind === 0 || !_vm.userInfo ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.refrralText,
      expression: "refrralText"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter referral code"
    },
    domProps: {
      "value": _vm.refrralText
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.refrralText = $event.target.value;
      }
    }
  }) : _vm._e()]), _vm.userInfo && _vm.userInfo.bind === 0 && _vm.isConnect === 'connected' ? _c('div', {
    staticClass: "btn btn-save",
    on: {
      "click": _vm.onReferralSave
    }
  }, [_vm._v(_vm._s(_vm.$lang("Apply Code")))]) : _vm.isConnect !== 'connected' ? _c('div', {
    staticClass: "btn btn-save connect",
    on: {
      "click": _vm.doConnect
    }
  }, [_vm._v(_vm._s(_vm.$lang("Connect Wallet")))]) : _vm._e()])])]), _c('div', {
    staticClass: "referral-list"
  }, [_c('div', {
    staticClass: "referral-item"
  }, [_c('div', {
    staticClass: "referral-item__title"
  }, [_vm._v(_vm._s(_vm.$lang("Share Link")))]), _c('div', {
    staticClass: "referral-item-info"
  }, [_c('div', {
    staticClass: "referral-input"
  }, [_c('div', {
    staticClass: "input"
  }, [_vm._v(" " + _vm._s(_vm.ReferralLink || "--") + " ")])]), _vm.isConnect === 'connected' && _vm.userInfo ? _c('div', {
    staticClass: "btn btn-save",
    on: {
      "click": function ($event) {
        return _vm.onCopy('referral link');
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang("Copy")))]) : _c('div', {
    staticClass: "btn btn-save connect",
    on: {
      "click": _vm.doConnect
    }
  }, [_vm._v(_vm._s(_vm.$lang("Connect Wallet")))])])]), _c('div', {
    staticClass: "referral-item"
  }, [_c('div', {
    staticClass: "referral-item__title"
  }, [_vm._v(_vm._s(_vm.$lang("Referral Code")))]), _c('div', {
    staticClass: "referral-item-info"
  }, [_c('div', {
    staticClass: "referral-input"
  }, [_c('div', {
    staticClass: "input"
  }, [_vm._v(" " + _vm._s(_vm.ReferralCode || "--") + " ")])]), _vm.isConnect === 'connected' && _vm.userInfo ? _c('div', {
    staticClass: "btn btn-save",
    on: {
      "click": function ($event) {
        return _vm.onCopy('referral Code');
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang("Copy")))]) : _c('div', {
    staticClass: "btn btn-save connect",
    on: {
      "click": _vm.doConnect
    }
  }, [_vm._v(_vm._s(_vm.$lang("Connect Wallet")))])])])])])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "referral-intro__label"
  }, [_vm._v("Share your link and earn bonus Pop Points from your network: "), _c('i', [_vm._v("15%")]), _vm._v(" from direct referrals and "), _c('i', [_vm._v("10%")]), _vm._v(" from indirect referrals.")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "referral-total__img"
  }, [_c('img', {
    attrs: {
      "src": require("@images/ui/wave-logo.svg"),
      "alt": "Wave points"
    }
  })]);
}];
export { render, staticRenderFns };